import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProductCard } from '../components/ProductCard';
import { ChevronRightIcon, MinusIcon, PlusIcon, TruckIcon, ShieldCheckIcon, HeartIcon, StarIcon, CheckIcon, LeafIcon, RefreshCwIcon, InfoIcon } from 'lucide-react';
// Featured product data
const featuredProduct = {
  id: 'featured-1',
  name: 'Premium Rose Collection',
  price: 5800,
  description: 'Our signature Premium Rose Collection features the finest long-stemmed roses sourced directly from the highlands of Kenya. Each bloom is carefully selected for its vibrant color, perfect form, and long-lasting freshness. This luxury arrangement is perfect for special occasions, anniversaries, or as an impressive gift for someone you love.',
  longDescription: 'The Premium Rose Collection represents the pinnacle of floral luxury. Each rose is hand-picked at the perfect stage of bloom from our partner farms in the Kenyan highlands, where the ideal climate and rich soil produce roses of exceptional quality and longevity.\n\nOur skilled florists arrange these stunning blooms with complementary foliage and accent flowers to create a truly breathtaking display. The arrangement comes in an elegant vase and includes our premium plant food formula to ensure your roses stay fresh for up to 14 days.\n\nWe offer same-day delivery in Nairobi for orders placed before 2pm, and next-day delivery to other major cities across Kenya.',
  images: ['https://images.unsplash.com/photo-1561181286-d3fee3785613?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1548094990-c16ca90f1f0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1455582916367-25f75bfc6710?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['Red', 'Pink', 'White', 'Yellow', 'Mixed'],
  bouquetSizes: ['Classic (12 stems)', 'Deluxe (24 stems)', 'Grand (36 stems)'],
  vaseOptions: ['Clear Glass Vase (+KES 1,500)', 'Ceramic Vase (+KES 2,000)', 'No Vase'],
  rating: 4.9,
  reviewCount: 189,
  features: ['Hand-selected premium roses', 'Professionally arranged by expert florists', 'Includes care instructions and flower food', 'Eco-friendly packaging', '7-day freshness guarantee'],
  category: 'Premium Collections',
  tags: ['roses', 'luxury', 'gift', 'anniversary', 'birthday', 'romance'],
  isNew: true,
  isBestseller: true
};
// Related products
const relatedProducts = [{
  id: '1',
  name: 'Elegant Rose Bouquet',
  price: 3500,
  image: 'https://images.unsplash.com/photo-1548094990-c16ca90f1f0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  isNew: true
}, {
  id: '3',
  name: 'Sunshine Sunflower Arrangement',
  price: 4200,
  image: 'https://images.unsplash.com/photo-1593106410242-b3c438e8e012?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Arrangements',
  isBestseller: true
}, {
  id: '4',
  name: 'Exotic Orchid Collection',
  price: 6500,
  image: 'https://images.unsplash.com/photo-1566408669374-5a6d5dca6b39?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Exotic'
}];
// All products data (simplified version of what's in ProductDetail.tsx)
const allProducts = [{
  id: '1',
  name: 'Elegant Rose Bouquet',
  price: 3500,
  image: 'https://images.unsplash.com/photo-1548094990-c16ca90f1f0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  isNew: true
}, {
  id: '3',
  name: 'Sunshine Sunflower Arrangement',
  price: 4200,
  image: 'https://images.unsplash.com/photo-1593106410242-b3c438e8e012?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Arrangements',
  isBestseller: true
}, {
  id: '4',
  name: 'Exotic Orchid Collection',
  price: 6500,
  image: 'https://images.unsplash.com/photo-1566408669374-5a6d5dca6b39?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Exotic'
}, {
  id: 'featured-1',
  name: 'Premium Rose Collection',
  price: 5800,
  image: 'https://images.unsplash.com/photo-1561181286-d3fee3785613?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Premium Collections',
  isNew: true,
  isBestseller: true
}];
export function SingleProduct() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  // If id is provided, use it to find the product, otherwise use featuredProduct
  const product = id ? allProducts.find(p => p.id === id) || featuredProduct : featuredProduct;
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState(featuredProduct.colors[0]);
  const [selectedSize, setSelectedSize] = useState(featuredProduct.bouquetSizes[0]);
  const [selectedVase, setSelectedVase] = useState(featuredProduct.vaseOptions[0]);
  const [activeTab, setActiveTab] = useState('description');
  // Calculate if shipping is free
  const isShippingFree = product.price * quantity >= 6000;
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-1187">
      <Header data-id="element-1188" />
      <main className="flex-grow" data-id="element-1189">
        {/* Hero Banner */}
        <div className="bg-pink-700 text-white" data-id="element-1190">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-1191">
            <div className="flex justify-between items-center" data-id="element-1192">
              <div data-id="element-1193">
                <h1 className="text-2xl font-bold" data-id="element-1194">
                  {id ? product.name : 'Featured Product'}
                </h1>
                <p className="text-pink-100" data-id="element-1195">
                  {id ? `From our ${product.category} collection` : 'Our most exclusive floral arrangement'}
                </p>
              </div>
              <div className="hidden md:block" data-id="element-1196">
                <div className="flex items-center space-x-4" data-id="element-1197">
                  <div className="flex items-center" data-id="element-1198">
                    <StarIcon className="h-5 w-5 text-yellow-300" data-id="element-1199" />
                    <span className="ml-1 font-medium" data-id="element-1200">
                      {featuredProduct.rating} Rating
                    </span>
                  </div>
                  <div className="h-4 w-px bg-pink-400" data-id="element-1201"></div>
                  <div className="flex items-center" data-id="element-1202">
                    <TruckIcon className="h-5 w-5 text-pink-100" data-id="element-1203" />
                    <span className="ml-1" data-id="element-1204">
                      {isShippingFree ? 'Free Delivery' : 'Fast Delivery'}
                    </span>
                  </div>
                  <div className="h-4 w-px bg-pink-400" data-id="element-1205"></div>
                  <div className="flex items-center" data-id="element-1206">
                    <ShieldCheckIcon className="h-5 w-5 text-pink-100" data-id="element-1207" />
                    <span className="ml-1" data-id="element-1208">Freshness Guarantee</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Breadcrumbs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-1209">
          <nav className="flex text-sm" data-id="element-1210">
            <Link to="/" className="text-gray-500 hover:text-gray-700" data-id="element-1211">
              Home
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400 flex-shrink-0 self-center" data-id="element-1212" />
            <Link to="/shop" className="text-gray-500 hover:text-gray-700" data-id="element-1213">
              Shop
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400 flex-shrink-0 self-center" data-id="element-1214" />
            <Link to={`/shop?category=${product.category}`} className="text-gray-500 hover:text-gray-700" data-id="element-1215">
              {product.category}
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400 flex-shrink-0 self-center" data-id="element-1216" />
            <span className="text-gray-900 font-medium" data-id="element-1217">{product.name}</span>
          </nav>
        </div>
        {/* Product Details */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-1218">
          <div className="lg:grid lg:grid-cols-2 lg:gap-x-12" data-id="element-1219">
            {/* Product images */}
            <div className="lg:self-start" data-id="element-1220">
              <div className="aspect-w-1 aspect-h-1 overflow-hidden rounded-lg mb-4" data-id="element-1221">
                <img src={featuredProduct.images[selectedImage]} alt={featuredProduct.name} className="w-full h-[500px] object-cover object-center" data-id="element-1222" />
              </div>
              <div className="flex gap-4 mt-4 overflow-x-auto pb-2" data-id="element-1223">
                {featuredProduct.images.map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`relative rounded-md overflow-hidden w-24 h-24 flex-shrink-0 ${selectedImage === index ? 'ring-2 ring-emerald-500' : 'ring-1 ring-gray-200'}`} data-id="element-1224">
                    <img src={image} alt={`${featuredProduct.name} view ${index + 1}`} className="w-full h-full object-cover object-center" data-id="element-1225" />
                  </button>)}
              </div>
              {/* Product badges */}
              <div className="flex flex-wrap gap-2 mt-6" data-id="element-1226">
                {product.isNew && <span className="px-3 py-1 bg-emerald-100 text-emerald-800 text-xs font-medium rounded-full" data-id="element-1227">
                    New Arrival
                  </span>}
                {product.isBestseller && <span className="px-3 py-1 bg-amber-100 text-amber-800 text-xs font-medium rounded-full" data-id="element-1228">
                    Bestseller
                  </span>}
                <span className="px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full" data-id="element-1229">
                  Premium Quality
                </span>
                {isShippingFree && <span className="px-3 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full" data-id="element-1230">
                    Free Delivery
                  </span>}
              </div>
            </div>
            {/* Product info */}
            <div className="mt-10 lg:mt-0" data-id="element-1231">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-1232">
                {product.name}
              </h1>
              <div className="mt-3 flex items-center" data-id="element-1233">
                <div className="flex items-center" data-id="element-1234">
                  {[0, 1, 2, 3, 4].map(rating => <StarIcon key={rating} className={`h-5 w-5 flex-shrink-0 ${featuredProduct.rating > rating ? 'text-yellow-400' : 'text-gray-300'}`} data-id="element-1235" />)}
                </div>
                <p className="ml-2 text-sm text-gray-600" data-id="element-1236">
                  {featuredProduct.rating} ({featuredProduct.reviewCount}{' '}
                  reviews)
                </p>
              </div>
              <div className="mt-4" data-id="element-1237">
                <p className="text-3xl font-bold text-pink-700" data-id="element-1238">
                  KES {product.price.toLocaleString()}
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1239">
                  Includes taxes.{' '}
                  {isShippingFree ? 'Free shipping in Nairobi.' : 'Shipping calculated at checkout.'}
                </p>
              </div>
              <div className="mt-6" data-id="element-1240">
                <p className="text-base text-gray-700" data-id="element-1241">
                  {featuredProduct.description}
                </p>
              </div>
              <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-1242">
                <form data-id="element-1243">
                  {/* Color selector */}
                  <div className="mb-6" data-id="element-1244">
                    <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1245">
                      Color
                    </h3>
                    <div className="flex flex-wrap gap-2" data-id="element-1246">
                      {featuredProduct.colors.map(color => <button key={color} type="button" onClick={() => setSelectedColor(color)} className={`px-4 py-2 rounded-md text-sm ${selectedColor === color ? 'bg-pink-700 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-1247">
                          {color}
                        </button>)}
                    </div>
                  </div>
                  {/* Size selector */}
                  <div className="mb-6" data-id="element-1248">
                    <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1249">
                      Bouquet Size
                    </h3>
                    <div className="flex flex-wrap gap-2" data-id="element-1250">
                      {featuredProduct.bouquetSizes.map(size => <button key={size} type="button" onClick={() => setSelectedSize(size)} className={`px-4 py-2 rounded-md text-sm ${selectedSize === size ? 'bg-pink-700 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-1251">
                          {size}
                        </button>)}
                    </div>
                  </div>
                  {/* Vase options */}
                  <div className="mb-6" data-id="element-1252">
                    <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1253">
                      Vase Option
                    </h3>
                    <div className="flex flex-col gap-2" data-id="element-1254">
                      {featuredProduct.vaseOptions.map(vase => <label key={vase} className={`flex items-center p-3 rounded-md ${selectedVase === vase ? 'bg-emerald-50 border border-emerald-200' : 'border border-gray-200 hover:bg-gray-50'}`} data-id="element-1255">
                          <input type="radio" name="vase-option" checked={selectedVase === vase} onChange={() => setSelectedVase(vase)} className="h-4 w-4 text-pink-700 focus:ring-pink-500 border-gray-300" data-id="element-1256" />
                          <span className="ml-3 text-sm text-gray-800" data-id="element-1257">
                            {vase}
                          </span>
                        </label>)}
                    </div>
                  </div>
                  {/* Quantity selector */}
                  <div className="mb-6" data-id="element-1258">
                    <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1259">
                      Quantity
                    </h3>
                    <div className="flex items-center" data-id="element-1260">
                      <button type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))} className="p-2 border border-gray-300 rounded-l-md bg-gray-50 hover:bg-gray-100" data-id="element-1261">
                        <MinusIcon className="h-4 w-4 text-gray-600" data-id="element-1262" />
                      </button>
                      <input type="number" min="1" value={quantity} onChange={e => setQuantity(Math.max(1, parseInt(e.target.value) || 1))} className="p-2 w-16 text-center border-t border-b border-gray-300 focus:outline-none focus:ring-0 focus:border-gray-300" data-id="element-1263" />
                      <button type="button" onClick={() => setQuantity(quantity + 1)} className="p-2 border border-gray-300 rounded-r-md bg-gray-50 hover:bg-gray-100" data-id="element-1264">
                        <PlusIcon className="h-4 w-4 text-gray-600" data-id="element-1265" />
                      </button>
                    </div>
                  </div>
                  {/* Add to cart and wishlist buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 mt-8" data-id="element-1266">
                    <button type="button" className="flex-1 bg-pink-700 text-white py-3 px-6 rounded-md hover:bg-pink-800 transition-colors flex items-center justify-center" data-id="element-1267">
                      Add to Cart
                    </button>
                    <button type="button" className="flex-1 bg-pink-100 text-pink-800 py-3 px-6 rounded-md hover:bg-pink-200 transition-colors flex items-center justify-center" data-id="element-1268">
                      Buy Now
                    </button>
                    <button type="button" className="p-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors flex items-center justify-center" data-id="element-1269">
                      <HeartIcon className="h-5 w-5" data-id="element-1270" />
                    </button>
                  </div>
                </form>
              </div>
              {/* Key features */}
              <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-1271">
                <h3 className="text-sm font-medium text-gray-900 mb-4" data-id="element-1272">
                  Key Features
                </h3>
                <ul className="space-y-3" data-id="element-1273">
                  {featuredProduct.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-1274">
                      <CheckIcon className="h-5 w-5 text-emerald-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-1275" />
                      <span className="text-gray-600" data-id="element-1276">{feature}</span>
                    </li>)}
                </ul>
              </div>
              {/* Delivery info */}
              <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-1277">
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-1278">
                  <div className="flex" data-id="element-1279">
                    <div className="flex-shrink-0" data-id="element-1280">
                      <TruckIcon className="h-5 w-5 text-emerald-600" data-id="element-1281" />
                    </div>
                    <div className="ml-3" data-id="element-1282">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-1283">
                        {isShippingFree ? 'Free delivery in Nairobi' : 'Delivery in Nairobi'}
                      </h4>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-1284">
                        {isShippingFree ? 'Orders placed before 2pm are delivered same day' : 'Free delivery for orders above KES 6,000. Orders placed before 2pm are delivered same day'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Product tabs */}
          <div className="mt-16 border-t border-gray-200 pt-8" data-id="element-1285">
            <div className="border-b border-gray-200" data-id="element-1286">
              <nav className="-mb-px flex space-x-8" data-id="element-1287">
                <button onClick={() => setActiveTab('description')} className={`pb-4 px-1 ${activeTab === 'description' ? 'border-b-2 border-pink-700 text-pink-700' : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} font-medium text-sm`} data-id="element-1288">
                  Description
                </button>
                <button onClick={() => setActiveTab('details')} className={`pb-4 px-1 ${activeTab === 'details' ? 'border-b-2 border-pink-700 text-pink-700' : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} font-medium text-sm`} data-id="element-1289">
                  Details & Care
                </button>
                <button onClick={() => setActiveTab('reviews')} className={`pb-4 px-1 ${activeTab === 'reviews' ? 'border-b-2 border-pink-700 text-pink-700' : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} font-medium text-sm`} data-id="element-1290">
                  Reviews ({featuredProduct.reviewCount})
                </button>
              </nav>
            </div>
            <div className="py-8" data-id="element-1291">
              {activeTab === 'description' && <div className="prose max-w-none" data-id="element-1292">
                  <p className="text-gray-700 whitespace-pre-line" data-id="element-1293">
                    {featuredProduct.longDescription}
                  </p>
                </div>}
              {activeTab === 'details' && <div className="space-y-6" data-id="element-1294">
                  <div data-id="element-1295">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-1296">
                      Product Details
                    </h3>
                    <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 text-sm" data-id="element-1297">
                      <div data-id="element-1298">
                        <dt className="font-medium text-gray-900" data-id="element-1299">Category</dt>
                        <dd className="mt-1 text-gray-700" data-id="element-1300">
                          {featuredProduct.category}
                        </dd>
                      </div>
                      <div data-id="element-1301">
                        <dt className="font-medium text-gray-900" data-id="element-1302">
                          Available Colors
                        </dt>
                        <dd className="mt-1 text-gray-700" data-id="element-1303">
                          {featuredProduct.colors.join(', ')}
                        </dd>
                      </div>
                      <div data-id="element-1304">
                        <dt className="font-medium text-gray-900" data-id="element-1305">
                          Available Sizes
                        </dt>
                        <dd className="mt-1 text-gray-700" data-id="element-1306">
                          {featuredProduct.bouquetSizes.join(', ')}
                        </dd>
                      </div>
                      <div data-id="element-1307">
                        <dt className="font-medium text-gray-900" data-id="element-1308">Tags</dt>
                        <dd className="mt-1 text-gray-700" data-id="element-1309">
                          {featuredProduct.tags.join(', ')}
                        </dd>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1310">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-1311">
                      Care Instructions
                    </h3>
                    <div className="mt-4 space-y-4" data-id="element-1312">
                      <div className="flex" data-id="element-1313">
                        <div className="flex-shrink-0" data-id="element-1314">
                          <LeafIcon className="h-5 w-5 text-pink-700" data-id="element-1315" />
                        </div>
                        <div className="ml-3" data-id="element-1316">
                          <h4 className="text-sm font-medium text-gray-900" data-id="element-1317">
                            Water
                          </h4>
                          <p className="mt-1 text-sm text-gray-700" data-id="element-1318">
                            Change water every 2-3 days. Use lukewarm water to
                            promote better absorption.
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-1319">
                        <div className="flex-shrink-0" data-id="element-1320">
                          <RefreshCwIcon className="h-5 w-5 text-pink-700" data-id="element-1321" />
                        </div>
                        <div className="ml-3" data-id="element-1322">
                          <h4 className="text-sm font-medium text-gray-900" data-id="element-1323">
                            Trimming
                          </h4>
                          <p className="mt-1 text-sm text-gray-700" data-id="element-1324">
                            Trim stems at a 45-degree angle every 2-3 days to
                            maximize water intake.
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-1325">
                        <div className="flex-shrink-0" data-id="element-1326">
                          <InfoIcon className="h-5 w-5 text-pink-700" data-id="element-1327" />
                        </div>
                        <div className="ml-3" data-id="element-1328">
                          <h4 className="text-sm font-medium text-gray-900" data-id="element-1329">
                            Environment
                          </h4>
                          <p className="mt-1 text-sm text-gray-700" data-id="element-1330">
                            Keep away from direct sunlight, heat sources, and
                            ripening fruits.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {activeTab === 'reviews' && <div data-id="element-1331">
                  <div className="flex items-center justify-between" data-id="element-1332">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-1333">
                      Customer Reviews
                    </h3>
                    <button className="text-sm font-medium text-pink-700 hover:text-pink-500" data-id="element-1334">
                      Write a review
                    </button>
                  </div>
                  <div className="mt-6 border-t border-b border-gray-200 py-6" data-id="element-1335">
                    <div className="flex items-start" data-id="element-1336">
                      <div className="flex-shrink-0" data-id="element-1337">
                        <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="h-10 w-10 rounded-full" data-id="element-1338" />
                      </div>
                      <div className="ml-4" data-id="element-1339">
                        <h4 className="text-sm font-bold text-gray-900" data-id="element-1340">
                          Sarah M.
                        </h4>
                        <div className="mt-1 flex items-center" data-id="element-1341">
                          {[0, 1, 2, 3, 4].map(rating => <StarIcon key={rating} className="h-4 w-4 text-yellow-400" data-id="element-1342" />)}
                          <span className="ml-2 text-sm text-gray-500" data-id="element-1343">
                            2 days ago
                          </span>
                        </div>
                        <p className="mt-2 text-sm text-gray-700" data-id="element-1344">
                          Absolutely stunning arrangement! The roses were fresh
                          and beautifully arranged. They lasted for almost two
                          weeks, which is impressive. The delivery was prompt
                          and the packaging was excellent. Will definitely order
                          again!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="border-b border-gray-200 py-6" data-id="element-1345">
                    <div className="flex items-start" data-id="element-1346">
                      <div className="flex-shrink-0" data-id="element-1347">
                        <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="h-10 w-10 rounded-full" data-id="element-1348" />
                      </div>
                      <div className="ml-4" data-id="element-1349">
                        <h4 className="text-sm font-bold text-gray-900" data-id="element-1350">
                          John D.
                        </h4>
                        <div className="mt-1 flex items-center" data-id="element-1351">
                          {[0, 1, 2, 3, 4].map(rating => <StarIcon key={rating} className={`h-4 w-4 ${rating < 4 ? 'text-yellow-400' : 'text-gray-300'}`} data-id="element-1352" />)}
                          <span className="ml-2 text-sm text-gray-500" data-id="element-1353">
                            1 week ago
                          </span>
                        </div>
                        <p className="mt-2 text-sm text-gray-700" data-id="element-1354">
                          Bought these for my wife's birthday and she loved
                          them! The roses were gorgeous and arrived right on
                          time. The only small issue was that one of the blooms
                          was slightly damaged, but the overall arrangement was
                          still beautiful.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 text-center" data-id="element-1355">
                    <button className="text-sm font-medium text-pink-700 hover:text-pink-500" data-id="element-1356">
                      Load more reviews
                    </button>
                  </div>
                </div>}
            </div>
          </div>
          {/* Related products */}
          <div className="mt-16 border-t border-gray-200 pt-16" data-id="element-1357">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1358">
              You might also like
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-10" data-id="element-1359">
              {relatedProducts.map(product => <ProductCard key={product.id} id={product.id} name={product.name} price={product.price} image={product.image} category={product.category} isNew={product.isNew} isBestseller={product.isBestseller} data-id="element-1360" />)}
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1361" />
    </div>;
}